(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lokaliza-product-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lokaliza-carousel]').forEach((carousel) => {
    if (carousel.dataset.ready) return;
    carousel.dataset.ready = 'true';
    const track = carousel.querySelector('[data-carousel-track]');
    const dots = [...carousel.querySelectorAll('[data-carousel-dot]')];
    const counter = carousel.querySelector('[data-carousel-current]');
    let index = 0;
    let touchStart = 0;
    const show = (next) => {
      index = (next + dots.length) % dots.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
      counter.textContent = index + 1;
      dots[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };
    carousel.querySelector('[data-carousel-prev]').addEventListener('click', () => show(index - 1));
    carousel.querySelector('[data-carousel-next]').addEventListener('click', () => show(index + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.carouselDot))));
    track.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(distance) > 45) show(index + (distance < 0 ? 1 : -1));
    }, { passive: true });
  });
  document.querySelectorAll('[data-pack-selector]').forEach((selector) => {
    selector.querySelectorAll('[data-pack]').forEach((button) => button.addEventListener('click', () => {
      const form = selector.closest('form');
      form.querySelector('[data-pack-quantity]').value = button.dataset.pack;
      selector.querySelectorAll('[data-pack]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }));
  });
  document.querySelectorAll('[data-accessory-form]').forEach((form) => {
    if (form.dataset.accessoryReady) return;
    form.dataset.accessoryReady = 'true';
    form.addEventListener('submit', async (event) => {
      const selected = [...form.querySelectorAll('[data-accessory-check]:checked')];
      if (!selected.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const submit = form.querySelector('[type="submit"]');
      const original = submit.innerHTML;
      submit.disabled = true;
      submit.textContent = 'AGREGANDO TU PEDIDO…';
      const mainVariant = form.querySelector('[name="id"]').value;
      const mainQuantity = Number(form.querySelector('[data-pack-quantity]').value || 1);
      const items = [{ id: Number(mainVariant), quantity: mainQuantity }];
      selected.forEach((checkbox) => {
        const card = checkbox.closest('.lz__accessory');
        const variantSelect = card.querySelector('[data-accessory-variant]');
        const variantId = variantSelect ? variantSelect.value : checkbox.dataset.variantId;
        if (variantId) items.push({ id: Number(variantId), quantity: 1 });
      });
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('No fue posible agregar el pedido');
        window.location.assign(`${window.Shopify.routes.root}cart`);
      } catch (error) {
        submit.disabled = false;
        submit.innerHTML = original;
        window.alert('No pudimos agregar todos los productos. Inténtalo nuevamente.');
      }
    }, true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
